/**
 * Big Waster API
 * This is a Big Waster API.
 *
 * OpenAPI spec version: 1.0
 * Contact: terry.wong@futureimpactlab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import BagorderQueryResult from './BagorderQueryResult';

/**
 * The BagorderOutput model module.
 * @module model/BagorderOutput
 * @version 1.0
 */
class BagorderOutput {
    /**
     * Constructs a new <code>BagorderOutput</code>.
     * @alias module:model/BagorderOutput
     */
    constructor() { 
        
        BagorderOutput.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>BagorderOutput</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/BagorderOutput} obj Optional instance to populate.
     * @return {module:model/BagorderOutput} The populated <code>BagorderOutput</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new BagorderOutput();

            if (data.hasOwnProperty('bagOrder')) {
                obj['bagOrder'] = ApiClient.convertToType(data['bagOrder'], [BagorderQueryResult]);
            }
        }
        return obj;
    }


}

/**
 * @member {Array.<module:model/BagorderQueryResult>} bagOrder
 */
BagorderOutput.prototype['bagOrder'] = undefined;






export default BagorderOutput;

